<div class="overflow-x-hidden bg-white font-inter text-slate-950">

  <!-- Hero -->
  <div class="border-b border-slate-100 bg-slate-50 px-4 py-20 sm:px-6 lg:px-8">
    <div class="mx-auto flex max-w-page flex-col gap-8">
      <div class="flex flex-col gap-6">
        <div class="flex flex-col gap-4">
          <p class="text-body3 font-medium uppercase tracking-widest text-primary-600">Contact sales</p>
          <h1 class="max-w-3xl text-[3rem] font-normal leading-[1.05] tracking-[-0.04em] text-black sm:text-[4rem]">
            Let's build the right<br>
            <span class="text-slate-400">plan for your team</span>
          </h1>
        </div>
        <p class="max-w-2xl text-[1.2rem] leading-8 text-slate-500">
          Tell us about your organization and we'll help you evaluate FormOps for
          enterprise-scale form operations, AI insights, and team workflows.
        </p>
      </div>

      @if (planKey()) {
        <div class="inline-flex items-center gap-2 self-start rounded-full border border-primary-200 bg-primary-50 px-5 py-2.5 text-body2 text-primary-800">
          <span class="font-medium">Interested in:</span>
          <span>{{ selectedPlanLabel() }}</span>
        </div>
      }
    </div>
  </div>

  <!-- Form + Benefits -->
  <div class="px-4 py-16 sm:px-6 lg:px-8">
    <div class="mx-auto grid max-w-page gap-16 lg:grid-cols-2 lg:gap-24">

      <!-- Contact Form -->
      <div>
        @if (submitted()) {
          <div class="flex flex-col items-center gap-8 rounded-3xl border border-slate-200 bg-slate-50 px-8 py-12 text-center">
            <div class="flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-2xl text-primary-600">
              ✓
            </div>
            <div class="flex flex-col gap-3">
              <h2 class="text-h4 text-slate-950">Thanks for reaching out</h2>
              <p class="text-body1 text-slate-500">
                Our team will get back to you within 1 business day.
              </p>
            </div>
            <a
              routerLink="/pricing"
              class="inline-flex h-12 items-center rounded-full border border-slate-200 bg-white px-7 text-body2 font-medium text-slate-700 transition hover:border-slate-300 hover:bg-slate-50">
              Back to pricing
            </a>
          </div>
        } @else {
          <div class="flex flex-col gap-8">
            <div class="flex flex-col gap-2">
              <h2 class="text-h4 text-slate-950">Get in touch</h2>
              <p class="text-body1 text-slate-500">
                Fill out the form and a member of our sales team will contact you shortly.
              </p>
            </div>

            <form [signalForm]="contactForm">
              <div class="flex flex-col gap-5">
                <div class="grid gap-4 sm:grid-cols-2">
                  <lib-signal-text-field
                    [formField]="contactForm.firstName"
                    label="First name"
                    placeholder="Jane"
                    autocomplete="given-name" />
                  <lib-signal-text-field
                    [formField]="contactForm.lastName"
                    label="Last name"
                    placeholder="Doe"
                    autocomplete="family-name" />
                </div>

                <lib-signal-text-field
                  [formField]="contactForm.companyName"
                  label="Company name"
                  placeholder="Acme Inc."
                  autocomplete="organization" />

                <lib-signal-text-field
                  [formField]="contactForm.email"
                  label="Email"
                  inputType="email"
                  placeholder="you@company.com"
                  autocomplete="email" />

                <lib-signal-textarea
                  [formField]="contactForm.message"
                  label="How can we help?"
                  placeholder="Tell us about your team size, use case, and timeline..."
                  [rows]="5" />

                <div class="pt-2">
                  <lib-signal-button
                    type="submit"
                    (clicked)="onSubmit()">
                    Send message
                  </lib-signal-button>
                </div>
              </div>
            </form>
          </div>
        }
      </div>

      <!-- Benefits -->
      <div class="flex flex-col gap-8 lg:pt-8">
        <div class="flex flex-col gap-3">
          <h2 class="text-h4 text-slate-950">Why teams choose FormOps Enterprise</h2>
          <p class="text-body1 leading-7 text-slate-500">
            From security and compliance to custom onboarding, we partner with you
            to deploy FormOps across your organization.
          </p>
        </div>

        <ul class="flex flex-col gap-5">
          @for (benefit of benefits; track benefit) {
            <li class="flex items-start gap-4">
              <span class="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-primary-100 text-body3 font-semibold text-primary-700">
                ✓
              </span>
              <span class="text-body1 text-slate-600">{{ benefit }}</span>
            </li>
          }
        </ul>

        <div class="flex flex-col gap-4 rounded-2xl border border-slate-200 bg-slate-50 p-6">
          <p class="text-body2 font-medium text-slate-950">Prefer self-service?</p>
          <p class="text-body2 text-slate-500">
            Explore our standard plans and start building in minutes.
          </p>
          <a
            routerLink="/pricing"
            class="inline-flex h-11 self-start items-center rounded-full border border-slate-200 bg-white px-6 text-body2 font-medium text-slate-700 transition hover:border-slate-300 hover:bg-white">
            View pricing
          </a>
        </div>
      </div>

    </div>
  </div>

</div>
